export enum SystemConfiguration { 
    AccountScreenDefaultDateRange = "AccountScreenDefaultDateRange",
    AcquaintAppMode = "AcquaintAppMode",
    AddressDefault = "AddressDefault",
    AddressLabel1NamePreference = "AddressLabel1NamePreference",
    AddressLabelExcludeRegion = "AddressLabelExcludeRegion",
    AddressLabelUnknownAddressee = "AddressLabelUnknownAddressee",
    AddressSuppressTownIfLocality = "AddressSuppressTownIfLocality",
    AgencyExpressAccountCode = "AgencyExpressAccountCode",
    AgencyExpressAPIKey = "AgencyExpressAPIKey",
    AIPropertyDescriptionPrompt = "AIPropertyDescriptionPrompt",
    AIPropertyRoomDescriptionPrompt = "AIPropertyRoomDescriptionPrompt",
    AllowUnclearedFundsPayments = "AllowUnclearedFundsPayments",
    AppointmentAutoConfirmContact = "AppointmentAutoConfirmContact",
    AppointmentCancellationEmailTemplate = "AppointmentCancellationEmailTemplate",
    AppointmentCancellationSMSTemplate = "AppointmentCancellationSMSTemplate",
    AppointmentCancelledBackColor = "AppointmentCancelledBackColor",
    AppointmentCancelledBackColor2 = "AppointmentCancelledBackColor2",
    AppointmentCancelledForeColor = "AppointmentCancelledForeColor",
    AppointmentCompletionTypeID = "AppointmentCompletionTypeID",
    AppointmentConfirmationIncludeHMORelatedContacts = "AppointmentConfirmationIncludeHMORelatedContacts",
    AppointmentConfirmationsHomePageReminder = "AppointmentConfirmationsHomePageReminder",
    AppointmentDefaultDuration = "AppointmentDefaultDuration",
    AppointmentDiaryAutoRefresh = "AppointmentDiaryAutoRefresh",
    AppointmentDiaryShowFullDetails = "AppointmentDiaryShowFullDetails",
    AppointmentExchangeTypeID = "AppointmentExchangeTypeID",
    AppointmentIncludeContactDetailsForAllAttendees = "AppointmentIncludeContactDetailsForAllAttendees",
    AppointmentInspectionTypeID = "AppointmentInspectionTypeID",
    AppointmentListSuppressOwnerDetails = "AppointmentListSuppressOwnerDetails",
    AppointmentListSuppressTenantDetails = "AppointmentListSuppressTenantDetails",
    AppointmentNoShowBackColor = "AppointmentNoShowBackColor",
    AppointmentNoShowBackColor2 = "AppointmentNoShowBackColor2",
    AppointmentNoShowForeColor = "AppointmentNoShowForeColor",
    AppointmentRemindUnconfirmedPast = "AppointmentRemindUnconfirmedPast",
    AppointmentSendFeedbackRequestAfter = "AppointmentSendFeedbackRequestAfter",
    AppointmentSummaryUserNameFormat = "AppointmentSummaryUserNameFormat",
    AppointmentUnconfirmedBackColor = "AppointmentUnconfirmedBackColor",
    AppointmentUnconfirmedBackColor2 = "AppointmentUnconfirmedBackColor2",
    AppointmentUnconfirmedForeColor = "AppointmentUnconfirmedForeColor",
    AppointmentValuationTypeID = "AppointmentValuationTypeID",
    AssignDefaultMarketingEmailItems = "AssignDefaultMarketingEmailItems",
    AttachAppointmentInviteToConfirmationEmails = "AttachAppointmentInviteToConfirmationEmails",
    AttachContractorInvoicesToStatement = "AttachContractorInvoicesToStatement",
    AttachInvoiceToStatement = "AttachInvoiceToStatement",
    AttachPDFToLandlordWorkOrderEmail = "AttachPDFToLandlordWorkOrderEmail",
    AttachPDFToTenantWorkOrderEmail = "AttachPDFToTenantWorkOrderEmail",
    AuctionHouseFeedURL = "AuctionHouseFeedURL",
    AutoAddToMailingLists = "AutoAddToMailingLists",
    AutoCCLinkedContactsInBulkEmails = "AutoCCLinkedContactsInBulkEmails",
    AutomatedPropertyFeedback = "AutomatedPropertyFeedback",
    AutomatedPropertyFeedbackPrompt = "AutomatedPropertyFeedbackPrompt",
    AutomaticallyAcknowledgeMessagesAfterXDays = "AutomaticallyAcknowledgeMessagesAfterXDays",
    AutomaticallyShrinkFontToFitTextBoxes = "AutomaticallyShrinkFontToFitTextBoxes",
    AutomaticClosedownBackup = "AutomaticClosedownBackup",
    AutomaticDailyBackup = "AutomaticDailyBackup",
    AwaitingImage = "AwaitingImage",
    BackgroundProcessesLastRunDate = "BackgroundProcessesLastRunDate",
    BackgroundUpdatesRequired = "BackgroundUpdatesRequired",
    BackupNumber = "BackupNumber",
    BackupPath = "BackupPath",
    BankAccountClient = "BankAccountClient",
    BankAccountCurrent = "BankAccountCurrent",
    BankAccountDeposit = "BankAccountDeposit",
    BankAccountToReturnDepositFrom = "BankAccountToReturnDepositFrom",
    BaseFolder = "BaseFolder",
    BlockManagementPropertyID = "BlockManagementPropertyID",
    BlockManagementRightsObligationsInvoiceAttachment = "BlockManagementRightsObligationsInvoiceAttachment",
    BoardManagementSystem = "BoardManagementSystem",
    BookingDepositsRequired = "BookingDepositsRequired",
    BriefYourMarketExportPreTenancies = "BriefYourMarketExportPreTenancies",
    BriefYourMarketLastRunDate = "BriefYourMarketLastRunDate",
    BriefYourMarketPassword = "BriefYourMarketPassword",
    BriefYourMarketUploadErrors = "BriefYourMarketUploadErrors",
    BriefYourMarketUserName = "BriefYourMarketUserName",
    BulkAnonymiseHomePageReminder = "BulkAnonymiseHomePageReminder",
    BulkAnonymiseLastRunDate = "BulkAnonymiseLastRunDate",
    BulkAnonymiseNoActivity = "BulkAnonymiseNoActivity",
    BulkAnonymiseNoTransactions = "BulkAnonymiseNoTransactions",
    CaseConversionSpecialWords = "CaseConversionSpecialWords",
    ChargeIntroFeeOnRenewal = "ChargeIntroFeeOnRenewal",
    CheckApplicantDetailsWhenAddingToAppointment = "CheckApplicantDetailsWhenAddingToAppointment",
    ClickThroughLastDownloadDate = "ClickThroughLastDownloadDate",
    ClientMoneyProtectionSchemeID = "ClientMoneyProtectionSchemeID",
    ClientMoneyProtectionSchemeName = "ClientMoneyProtectionSchemeName",
    ClosedPeriodPassword = "ClosedPeriodPassword",
    CloseIncomingCallAlertsOnCallEnd = "CloseIncomingCallAlertsOnCallEnd",
    CompanyClosedPeriodEndDate = "CompanyClosedPeriodEndDate",
    CompanyFirstMonthFinancialYear = "CompanyFirstMonthFinancialYear",
    CompanyFirstMonthTaxYear = "CompanyFirstMonthTaxYear",
    CompanyInsurancePolicyNumber = "CompanyInsurancePolicyNumber",
    CompanyInsuranceProvider = "CompanyInsuranceProvider",
    CompanyLicenceNumber = "CompanyLicenceNumber",
    CompanyPropertyCategory = "CompanyPropertyCategory",
    CompanyRegistrationNumber = "CompanyRegistrationNumber",
    CompanyVATNumber = "CompanyVATNumber",
    CompressBackups = "CompressBackups",
    ConsentImportedData = "ConsentImportedData",
    CorrespondenceSubjectForeColor = "CorrespondenceSubjectForeColor",
    CorrespondenceSubjectBold = "CorrespondenceSubjectBold",
    CorrespondenceSubjectCRBeforeBody = "CorrespondenceSubjectCRBeforeBody",
    CountrywideSignsAgentReferenceLettings = "CountrywideSignsAgentReferenceLettings",
    CountrywideSignsAgentReferenceSales = "CountrywideSignsAgentReferenceSales",
    CreateIcionExport = "CreateIcionExport",
    CreatePointPressExport = "CreatePointPressExport",
    CreateSystemMessagesForNewProperties = "CreateSystemMessagesForNewProperties",
    CreateSystemMessagesForPropertyPriceChange = "CreateSystemMessagesForPropertyPriceChange",
    CreateSystemMessagesForPropertyStatusChange = "CreateSystemMessagesForPropertyStatusChange",
    CreditSafeOrganisationID = "CreditSafeOrganisationID",
    CreditSafePassword = "CreditSafePassword",
    CreditSafeUserName = "CreditSafeUserName",
    CustodialSchemeRentLimit = "CustodialSchemeRentLimit",
    CustomBankingFileAmountColumnPosition = "CustomBankingFileAmountColumnPosition",
    CustomBankingFileCreditColumnPosition = "CustomBankingFileCreditColumnPosition",
    CustomBankingFileDateColumnPosition = "CustomBankingFileDateColumnPosition",
    CustomBankingFileDebitColumnPosition = "CustomBankingFileDebitColumnPosition",
    CustomBankingFileHeaderRowPosition = "CustomBankingFileHeaderRowPosition",
    CustomBankingFileNameColumnPosition = "CustomBankingFileNameColumnPosition",
    CustomBankingFileReferenceColumnPosition = "CustomBankingFileReferenceColumnPosition",
    CustomerUploadLastRunDate = "CustomerUploadLastRunDate",
    DateToUseCreditPayCharge = "DateToUseCreditPayCharge",
    DeductHoldingDepositFrom = "DeductHoldingDepositFrom",
    DefaultContactMarketPosition = "DefaultContactMarketPosition",
    DefaultContactRetirement = "DefaultContactRetirement",
    DefaultContactSource = "DefaultContactSource",
    DefaultContactStatus = "DefaultContactStatus",
    DefaultContactType = "DefaultContactType",
    DefaultEmailFontFamily = "DefaultEmailFontFamily",
    DefaultEmailFontSize = "DefaultEmailFontSize",
    DefaultFeedbackReportMethod = "DefaultFeedbackReportMethod",
    DefaultFeedbackRequestMethod = "DefaultFeedbackRequestMethod",
    DefaultFinancialAdvisor = "DefaultFinancialAdvisor",
    DefaultInspectionFrequency = "DefaultInspectionFrequency",
    DefaultLonresPropertyOption = "DefaultLonresPropertyOption",
    DefaultMakePaymentsPaymentMethod = "DefaultMakePaymentsPaymentMethod",
    DefaultManagementTypeID = "DefaultManagementTypeID",
    DefaultMinimumTenancyTerm = "DefaultMinimumTenancyTerm",
    DefaultNoteType = "DefaultNoteType",
    DefaultPaymentMethod = "DefaultPaymentMethod",
    DefaultPaymentRunDateXDaysInFuture = "DefaultPaymentRunDateXDaysInFuture",
    DefaultPropertyAgencyType = "DefaultPropertyAgencyType",
    DefaultPropertyArea = "DefaultPropertyArea",
    DefaultPropertyBoardSupplier = "DefaultPropertyBoardSupplier",
    DefaultPropertyCategory = "DefaultPropertyCategory",
    DefaultPropertyElectricConnected = "DefaultPropertyElectricConnected",
    DefaultPropertyFurnished = "DefaultPropertyFurnished",
    DefaultPropertyGasConnected = "DefaultPropertyGasConnected",
    DefaultPropertyLocalAuthority = "DefaultPropertyLocalAuthority",
    DefaultPropertyManagementType = "DefaultPropertyManagementType",
    DefaultPropertyPriceFrequency = "DefaultPropertyPriceFrequency",
    DefaultPropertyPricePrefix = "DefaultPropertyPricePrefix",
    DefaultPropertyRentalTerms = "DefaultPropertyRentalTerms",
    DefaultPropertySalesCommissionInvoiceDueDate = "DefaultPropertySalesCommissionInvoiceDueDate",
    DefaultPropertyTaxBand = "DefaultPropertyTaxBand",
    DefaultPropertyTelephoneConnected = "DefaultPropertyTelephoneConnected",
    DefaultPropertyTenure = "DefaultPropertyTenure",
    DefaultPropertyType = "DefaultPropertyType",
    DefaultPropertyWaterConnected = "DefaultPropertyWaterConnected",
    DefaultRentArrearsInterestPercentage = "DefaultRentArrearsInterestPercentage",
    DefaultSolicitor = "DefaultSolicitor",
    DefaultTaskType = "DefaultTaskType",
    DefaultTenanciesPaymentMethod = "DefaultTenanciesPaymentMethod",
    DefaultTenanciesPrePaymentMethod = "DefaultTenanciesPrePaymentMethod",
    DefaultTenancyRenewalPeriod = "DefaultTenancyRenewalPeriod",
    DefaultWorkOrderCommissionPercentage = "DefaultWorkOrderCommissionPercentage",
    DefaultWorkOrderCommissionType = "DefaultWorkOrderCommissionType",
    DefaultWorkOrderType = "DefaultWorkOrderType",
    DefinableReportsPath = "DefinableReportsPath",
    DepositAmount = "DepositAmount",
    DepositHeld = "DepositHeld",
    DepositRatio = "DepositRatio",
    DepositRatioWeeks = "DepositRatioWeeks",
    DepositRounding = "DepositRounding",
    DepositScheme = "DepositScheme",
    DepositSchemePrompt = "DepositSchemePrompt",
    DiarySummaryDisplayOrder = "DiarySummaryDisplayOrder",
    DiarySyncLastRunDate = "DiarySyncLastRunDate",
    DiarySyncPeriod = "DiarySyncPeriod",
    DiaryTimeSlotInterval = "DiaryTimeSlotInterval",
    DownloadContactReferencesLastRunDate = "DownloadContactReferencesLastRunDate",
    ElectricityCertExpiryReminder = "ElectricityCertExpiryReminder",
    ElectricityCertReminderIntroductions = "ElectricityCertReminderIntroductions",
    ElectricityCertReminderRentCollect = "ElectricityCertReminderRentCollect",
    ElectricitySafetyReminderForLetPropertiesFrom = "ElectricitySafetyReminderForLetPropertiesFrom",
    EmailAppendHeaderMessageID = "EmailAppendHeaderMessageID",
    EmailBoardSupplierWhenBoardChanged = "EmailBoardSupplierWhenBoardChanged",
    EmailSendingPause = "EmailSendingPause",
    EmailSettingsPrompt = "EmailSettingsPrompt",
    EnableAdvancedTaskManagement = "EnableAdvancedTaskManagement",
    EnableMessagesForAllUsers = "EnableMessagesForAllUsers",
    EnablePropertyFeedbackToSendHomePageReminder = "EnablePropertyFeedbackToSendHomePageReminder",
    EnablePropertyLandUsage = "EnablePropertyLandUsage",
    EPCChartTitle = "EPCChartTitle",
    EPCImportPropertyFloorArea = "EPCImportPropertyFloorArea",
    EPCStartDate = "EPCStartDate",
    EstimatedCompletionDateAfterAcceptedOffer = "EstimatedCompletionDateAfterAcceptedOffer",
    ExternalSetting1 = "ExternalSetting1",
    ExternalSetting2 = "ExternalSetting2",
    ExternalSQLServer = "ExternalSQLServer",
    ExternalSQLServerDatabaseName = "ExternalSQLServerDatabaseName",
    ExternalSQLServerUserName = "ExternalSQLServerUserName",
    ExternalSQLServerUserPassword = "ExternalSQLServerUserPassword",
    FeedbackRequestSMSCreditsRequired = "FeedbackRequestSMSCreditsRequired",
    FinancialDocumentsAddressShowLinkedContacts = "FinancialDocumentsAddressShowLinkedContacts",
    FinancialModule = "FinancialModule",
    FixFloAccountType = "FixFloAccountType",
    FixFloAuthenticationToken = "FixFloAuthenticationToken",
    FixFloCustomDomain = "FixFloCustomDomain",
    FixFloErrors = "FixFloErrors",
    FixFloLastRunDate = "FixFloLastRunDate",
    FixFloManagementTypes = "FixFloManagementTypes",
    FTPServerName = "FTPServerName",
    GasCertExpiryReminder = "GasCertExpiryReminder",
    GasCertReminderIntroductions = "GasCertReminderIntroductions",
    GasCertReminderRentCollect = "GasCertReminderRentCollect",
    GDPRAutoSwitchOnRequired = "GDPRAutoSwitchOnRequired",
    GDPRCompliance = "GDPRCompliance",
    GeneralLetterheadID = "GeneralLetterheadID",
    GetNotifyRefreshToken = "GetNotifyRefreshToken",
    GrowthTrackAccessToken = "GrowthTrackAccessToken",
    GrowthTrackErrors = "GrowthTrackErrors",
    GrowthTrackLastRunDate = "GrowthTrackLastRunDate",
    GrowthTrackSubscriptionID = "GrowthTrackSubscriptionID",
    HeadOfficeEmailAddress = "HeadOfficeEmailAddress",
    HeadOfficeFiguresNextRunDate = "HeadOfficeFiguresNextRunDate",
    HomePageReminderRefresh = "HomePageReminderRefresh",
    IgnoreBranchesForRegistrationUserAssignment = "IgnoreBranchesForRegistrationUserAssignment",
    ImportAppointmentsLastRunDate = "ImportAppointmentsLastRunDate",
    ImportStandardLettersPrompt = "ImportStandardLettersPrompt",
    IncludeAcquaintAnywhereLinkWhenEmailingTask = "IncludeAcquaintAnywhereLinkWhenEmailingTask",
    IncludeWhat3WordsInAppointmentConfirmationEmails = "IncludeWhat3WordsInAppointmentConfirmationEmails",
    IncludeWhat3WordsInAppointmentConfirmationSMSTexts = "IncludeWhat3WordsInAppointmentConfirmationSMSTexts",
    InstallDate = "InstallDate",
    InterestRate = "InterestRate",
    InventoryBaseInspectionErrors = "InventoryBaseInspectionErrors",
    InventoryBasePropertyErrors = "InventoryBasePropertyErrors",
    InventoryBaseRefreshToken = "InventoryBaseRefreshToken",
    InventoryBaseUserName = "InventoryBaseUserName",
    InventorySystem = "InventorySystem",
    InventorySystemLastRunDate = "InventorySystemLastRunDate",
    InvoiceFooterText = "InvoiceFooterText",
    InvoiceFooterTextLettings = "InvoiceFooterTextLettings",
    InvoiceFooterTextSales = "InvoiceFooterTextSales",
    InvoiceLetterheadID = "InvoiceLetterheadID",
    InvoiceNumber = "InvoiceNumber",
    InvoiceNumberEndRange = "InvoiceNumberEndRange",
    InvoiceShowPropertyReference = "InvoiceShowPropertyReference",
    InvoiceShowRentPeriod = "InvoiceShowRentPeriod",
    KeySignOutForms = "KeySignOutForms",
    KeySignOutFormShowAddress = "KeySignOutFormShowAddress",
    KeySignOutLetterheadID = "KeySignOutLetterheadID",
    LandlordFee1Product = "LandlordFee1Product",
    LandlordFee2Product = "LandlordFee2Product",
    LandlordFee3Product = "LandlordFee3Product",
    LandlordIntroductionFee1Product = "LandlordIntroductionFee1Product",
    LandlordIntroductionFee2Product = "LandlordIntroductionFee2Product",
    LandlordPropertyAvailableTypeID = "LandlordPropertyAvailableTypeID",
    LandlordRegistrationLicencePeriod = "LandlordRegistrationLicencePeriod",
    LandlordRegistrationPrompt = "LandlordRegistrationPrompt",
    LandlordRegistrationRequired = "LandlordRegistrationRequired",
    LandlordRenewalFee1Product = "LandlordRenewalFee1Product",
    LandlordRenewalFee2Product = "LandlordRenewalFee2Product",
    LastLoginDate = "LastLoginDate",
    LastSystemInfoMessageID = "LastSystemInfoMessageID",
    LegalForLandlordsDefaultReportType = "LegalForLandlordsDefaultReportType",
    LegalForLandlordsLastRunDate = "LegalForLandlordsLastRunDate",
    LegalForLandlordsPassword = "LegalForLandlordsPassword",
    LegalForLandlordsUserID = "LegalForLandlordsUserID",
    LegalForLandlordsUserName = "LegalForLandlordsUserName",
    LegitimateInterest = "LegitimateInterest",
    LetterheadImageQuality = "LetterheadImageQuality",
    LetterheadPageMarginBottom = "LetterheadPageMarginBottom",
    LetterPackageFontFamily = "LetterPackageFontFamily",
    LettingFees = "LettingFees",
    LettingsModule = "LettingsModule",
    LicenceKey = "LicenceKey",
    Lonres = "Lonres",
    LonResPassword = "LonResPassword",
    LonResUserName = "LonResUserName",
    LookupTablesHighlightLastSelectedItem = "LookupTablesHighlightLastSelectedItem",
    MailChimpAPIKey = "MailChimpAPIKey",
    MailingRenewalPeriod = "MailingRenewalPeriod",
    MaintenanceRequestsLastRunDate = "MaintenanceRequestsLastRunDate",
    MappedDrive = "MappedDrive",
    MappedDrivePassword = "MappedDrivePassword",
    MappedDrivePath = "MappedDrivePath",
    MappedDriveUserName = "MappedDriveUserName",
    MarketingEmailDesignerPrompt = "MarketingEmailDesignerPrompt",
    MarketingEmailsBackgroundColour = "MarketingEmailsBackgroundColour",
    MarketingEmailsBodyColour = "MarketingEmailsBodyColour",
    MarketingEmailsBodyTextColour = "MarketingEmailsBodyTextColour",
    MarketingEmailsDetailBackgroundColour = "MarketingEmailsDetailBackgroundColour",
    MarketingEmailsDetailBorderColour = "MarketingEmailsDetailBorderColour",
    MarketingEmailsDetailTextColour = "MarketingEmailsDetailTextColour",
    MarketingEmailsFooterDividerColour = "MarketingEmailsFooterDividerColour",
    MarketingEmailsFooterTextColour = "MarketingEmailsFooterTextColour",
    MarketingEmailsHeadingColour = "MarketingEmailsHeadingColour",
    MarketingEmailsMenuColour = "MarketingEmailsMenuColour",
    MarketingEmailsMenuItemColour = "MarketingEmailsMenuItemColour",
    MarketingEmailsMenuItemSeperatorColour = "MarketingEmailsMenuItemSeperatorColour",
    MarketingEmailsMenuItemTextColour = "MarketingEmailsMenuItemTextColour",
    MarketingEmailsSocialMediaIconStyle = "MarketingEmailsSocialMediaIconStyle",
    MarketingPreferencesConfirmedHomePageReminder = "MarketingPreferencesConfirmedHomePageReminder",
    MarketingPreferencesRequestedHomePageReminder = "MarketingPreferencesRequestedHomePageReminder",
    MatchChildren = "MatchChildren",
    MatchPropertiesUnderOffer = "MatchPropertiesUnderOffer",
    MatchRenewalPeriod = "MatchRenewalPeriod",
    MyDepositsCustodialBranchID = "MyDepositsCustodialBranchID",
    MyDepositsCustodialOAuthAccessTokenAndRefreshToken = "MyDepositsCustodialOAuthAccessTokenAndRefreshToken",
    MyDepositsDownloadCertificatesLastRunDate = "MyDepositsDownloadCertificatesLastRunDate",
    MyDepositsInsuredBranchID = "MyDepositsInsuredBranchID",
    MyDepositsInsuredOAuthAccessTokenAndRefreshToken = "MyDepositsInsuredOAuthAccessTokenAndRefreshToken",
    NewPropertyOfferPurchaserEmailTemplate = "NewPropertyOfferPurchaserEmailTemplate",
    NewPropertyOfferPurchaserSMSTemplate = "NewPropertyOfferPurchaserSMSTemplate",
    NewPropertyOfferTenantEmailTemplate = "NewPropertyOfferTenantEmailTemplate",
    NewPropertyOfferTenantSMSTemplate = "NewPropertyOfferTenantSMSTemplate",
    NewPropertyOfferVendorEmailTemplate = "NewPropertyOfferVendorEmailTemplate",
    NewPropertyOfferVendorSMSTemplate = "NewPropertyOfferVendorSMSTemplate",
    NewTenancyReceivingPayment = "NewTenancyReceivingPayment",
    NextCouncilPaymentDateFortnightly = "NextCouncilPaymentDateFortnightly",
    NextCouncilPaymentDateFourWeekly = "NextCouncilPaymentDateFourWeekly",
    OnlineReferencePassword = "OnlineReferencePassword",
    OnlineReferencePrompt = "OnlineReferencePrompt",
    OnlineReferenceReportType = "OnlineReferenceReportType",
    OnlineReferenceSupplier = "OnlineReferenceSupplier",
    OnlineReferenceUserName = "OnlineReferenceUserName",
    OnlyMatchStudentsToStudentProperties = "OnlyMatchStudentsToStudentProperties",
    OriginatorIdentificationNumber = "OriginatorIdentificationNumber",
    OverseasTaxCalculationMethod = "OverseasTaxCalculationMethod",
    ParticularsDefaultTextColour = "ParticularsDefaultTextColour",
    ParticularsFooterBackgroundColour = "ParticularsFooterBackgroundColour",
    ParticularsFooterForegroundColour = "ParticularsFooterForegroundColour",
    ParticularsHeaderBackgroundColour = "ParticularsHeaderBackgroundColour",
    ParticularsHeaderForegroundColour = "ParticularsHeaderForegroundColour",
    ParticularsLogo = "ParticularsLogo",
    ParticularsPageBackgroundColour = "ParticularsPageBackgroundColour",
    ParticularsPictureBorderColour = "ParticularsPictureBorderColour",
    ParticularsShowFloorAreaForResidentialRooms = "ParticularsShowFloorAreaForResidentialRooms",
    PayAdvancedRentToLandlordsWhenReceived = "PayAdvancedRentToLandlordsWhenReceived",
    PaymentDay = "PaymentDay",
    PaymentExportFileFormat = "PaymentExportFileFormat",
    PaymentExportMergeContacts = "PaymentExportMergeContacts",
    PaymentRunNumber = "PaymentRunNumber",
    PayProp = "PayProp",
    PDFConversionQuality = "PDFConversionQuality",
    PlanetVerifyAccessToken = "PlanetVerifyAccessToken",
    PlanetVerifyAuthError = "PlanetVerifyAuthError",
    PlanetVerifyLastRunDate = "PlanetVerifyLastRunDate",
    PlanetVerifyPassword = "PlanetVerifyPassword",
    PlanetVerifyRefreshToken = "PlanetVerifyRefreshToken",
    PlanetVerifyUserName = "PlanetVerifyUserName",
    POSModule = "POSModule",
    PostcodeAnywhereAccountCode = "PostcodeAnywhereAccountCode",
    PostcodeAnywhereLicenseKey = "PostcodeAnywhereLicenseKey",
    PostcodeAnywherePassword = "PostcodeAnywherePassword",
    PostcodeLookupMethod = "PostcodeLookupMethod",
    PreTenancyReceivingPayment = "PreTenancyReceivingPayment",
    PreviewBeforeSendingAppointmentConfirmations = "PreviewBeforeSendingAppointmentConfirmations",
    PreviewBeforeSendingPropertyOffers = "PreviewBeforeSendingPropertyOffers",
    PreviewBeforeSendingWorkOrders = "PreviewBeforeSendingWorkOrders",
    PrintedMapMarkerColor = "PrintedMapMarkerColor",
    PrintedMapMarkerSize = "PrintedMapMarkerSize",
    PrintedMapZoomLevel = "PrintedMapZoomLevel",
    ProcessOutlookEmailsAssignFollowUpTasks = "ProcessOutlookEmailsAssignFollowUpTasks",
    ProcessOutlookEmailsDeleteRegistrationEmails = "ProcessOutlookEmailsDeleteRegistrationEmails",
    ProcessOutlookEmailsSetRegistrationEmailsAsRead = "ProcessOutlookEmailsSetRegistrationEmailsAsRead",
    PromptToSendSalesMemorandumWhenProgressingOffer = "PromptToSendSalesMemorandumWhenProgressingOffer",
    PropertyAcceptedStatusID = "PropertyAcceptedStatusID",
    PropertyAcceptedTypeID = "PropertyAcceptedTypeID",
    PropertyBulletinBGColor = "PropertyBulletinBGColor",
    PropertyBulletinFGColor = "PropertyBulletinFGColor",
    PropertyBulletinLinkColor = "PropertyBulletinLinkColor",
    PropertyBulletinLinkHoverColor = "PropertyBulletinLinkHoverColor",
    PropertyButtonPrompt = "PropertyButtonPrompt",
    PropertyButtonActive = "PropertyButtonActive",
    PropertyButtonID = "PropertyButtonID",
    PropertyButtonAllowActivationScreen = "PropertyButtonAllowActivationScreen",
    PropertyButtonShowAddressConfirmationPrompt = "PropertyButtonShowAddressConfirmationPrompt",
    PropertyCompletedStatusID = "PropertyCompletedStatusID",
    PropertyCompletedTypeID = "PropertyCompletedTypeID",
    PropertyCompletionHomePageReminder = "PropertyCompletionHomePageReminder",
    PropertyContractExpiry = "PropertyContractExpiry",
    PropertyDisclaimerNotice = "PropertyDisclaimerNotice",
    PropertyDisclaimerNoticeLettings = "PropertyDisclaimerNoticeLettings",
    PropertyEmailsUseBranding = "PropertyEmailsUseBranding",
    PropertyFeedbackAbbreviateApplicantName = "PropertyFeedbackAbbreviateApplicantName",
    PropertyFeedbackLastRunDate = "PropertyFeedbackLastRunDate",
    PropertyFeedbackLetterheadID = "PropertyFeedbackLetterheadID",
    PropertyFeedbackShowWebViewings = "PropertyFeedbackShowWebViewings",
    PropertyLandUsageSchemaEnabled = "PropertyLandUsageSchemaEnabled",
    PropertyLocation = "PropertyLocation",
    PropertyManagementModule = "PropertyManagementModule",
    PropertyMeasurementUnits = "PropertyMeasurementUnits",
    PropertyNetworkClientID = "PropertyNetworkClientID",
    PropertyNetworkClientSecret = "PropertyNetworkClientSecret",
    PropertyNetworkErrors = "PropertyNetworkErrors",
    PropertyNetworkLastRunDate = "PropertyNetworkLastRunDate",
    PropertyOfferAcceptedPurchaserEmailTemplate = "PropertyOfferAcceptedPurchaserEmailTemplate",
    PropertyOfferAcceptedPurchaserSMSTemplate = "PropertyOfferAcceptedPurchaserSMSTemplate",
    PropertyOfferAcceptedTenantEmailTemplate = "PropertyOfferAcceptedTenantEmailTemplate",
    PropertyOfferAcceptedTenantSMSTemplate = "PropertyOfferAcceptedTenantSMSTemplate",
    PropertyOfferAcceptedVendorEmailTemplate = "PropertyOfferAcceptedVendorEmailTemplate",
    PropertyOfferAcceptedVendorSMSTemplate = "PropertyOfferAcceptedVendorSMSTemplate",
    PropertyOfferAwaitingProofPurchaserEmailTemplate = "PropertyOfferAwaitingProofPurchaserEmailTemplate",
    PropertyOfferAwaitingProofPurchaserSMSTemplate = "PropertyOfferAwaitingProofPurchaserSMSTemplate",
    PropertyOfferAwaitingProofTenantEmailTemplate = "PropertyOfferAwaitingProofTenantEmailTemplate",
    PropertyOfferAwaitingProofTenantSMSTemplate = "PropertyOfferAwaitingProofTenantSMSTemplate",
    PropertyOfferAwaitingProofVendorEmailTemplate = "PropertyOfferAwaitingProofVendorEmailTemplate",
    PropertyOfferAwaitingProofVendorSMSTemplate = "PropertyOfferAwaitingProofVendorSMSTemplate",
    PropertyOfferRejectedPurchaserEmailTemplate = "PropertyOfferRejectedPurchaserEmailTemplate",
    PropertyOfferRejectedPurchaserSMSTemplate = "PropertyOfferRejectedPurchaserSMSTemplate",
    PropertyOfferRejectedTenantEmailTemplate = "PropertyOfferRejectedTenantEmailTemplate",
    PropertyOfferRejectedTenantSMSTemplate = "PropertyOfferRejectedTenantSMSTemplate",
    PropertyOfferRejectedVendorEmailTemplate = "PropertyOfferRejectedVendorEmailTemplate",
    PropertyOfferRejectedVendorSMSTemplate = "PropertyOfferRejectedVendorSMSTemplate",
    PropertyOfferStatusWhenPreTenancyCreated = "PropertyOfferStatusWhenPreTenancyCreated",
    PropertyOfferWithdrawnPurchaserEmailTemplate = "PropertyOfferWithdrawnPurchaserEmailTemplate",
    PropertyOfferWithdrawnPurchaserSMSTemplate = "PropertyOfferWithdrawnPurchaserSMSTemplate",
    PropertyOfferWithdrawnTenantEmailTemplate = "PropertyOfferWithdrawnTenantEmailTemplate",
    PropertyOfferWithdrawnTenantSMSTemplate = "PropertyOfferWithdrawnTenantSMSTemplate",
    PropertyOfferWithdrawnVendorEmailTemplate = "PropertyOfferWithdrawnVendorEmailTemplate",
    PropertyOfferWithdrawnVendorSMSTemplate = "PropertyOfferWithdrawnVendorSMSTemplate",
    PropertyParticularsListTemplate = "PropertyParticularsListTemplate",
    PropertyParticularsPrompt = "PropertyParticularsPrompt",
    PropertyParticularsTemplate = "PropertyParticularsTemplate",
    PropertyPriceMatchVariance = "PropertyPriceMatchVariance",
    PropertyRejectedStatusID = "PropertyRejectedStatusID",
    PropertyRejectedTypeID = "PropertyRejectedTypeID",
    PropertyRentalAcceptedStatusID = "PropertyRentalAcceptedStatusID",
    PropertyRentalAcceptedTypeID = "PropertyRentalAcceptedTypeID",
    PropertyRentalRejectedStatusID = "PropertyRentalRejectedStatusID",
    PropertyRentalRejectedTypeID = "PropertyRentalRejectedTypeID",
    PropertyViewerSuppressStreetNumber = "PropertyViewerSuppressStreetNumber",
    PropertyVisitHomePageReminder = "PropertyVisitHomePageReminder",
    PropertyVisitReminder = "PropertyVisitReminder",
    PropertyVisitReminderFirst = "PropertyVisitReminderFirst",
    PropertyVisitReminderIntro = "PropertyVisitReminderIntro",
    PropertyVisitReminderRentCollection = "PropertyVisitReminderRentCollection",
    RaiseRecurringFeesXDaysBeforeDue = "RaiseRecurringFeesXDaysBeforeDue",
    RavensworthBranchCode = "RavensworthBranchCode",
    ReceiptFooterText = "ReceiptFooterText",
    ReceiptFooterTextLettings = "ReceiptFooterTextLettings",
    ReceiptFooterTextSales = "ReceiptFooterTextSales",
    ReceiptLetterheadID = "ReceiptLetterheadID",
    ReceiptNumber = "ReceiptNumber",
    RedressSchemeID = "RedressSchemeID",
    RedressSchemeName = "RedressSchemeName",
    RenameFileMethod = "RenameFileMethod",
    RentDemandFooterText = "RentDemandFooterText",
    RentDemandLetterheadID = "RentDemandLetterheadID",
    RentDemandShowLandlordDetails = "RentDemandShowLandlordDetails",
    RentGuaranteePolicyHomePageReminder = "RentGuaranteePolicyHomePageReminder",
    RentReviewCoordinator = "RentReviewCoordinator",
    RentReviewHomePageReminder = "RentReviewHomePageReminder",
    RentReviewReminder = "RentReviewReminder",
    ReportHeaderBackgroundColour = "ReportHeaderBackgroundColour",
    ReportHeaderTextColour = "ReportHeaderTextColour",
    ReportLogo = "ReportLogo",
    ReportRowAlternateBackgroundColour = "ReportRowAlternateBackgroundColour",
    ReportRowBackgroundColour = "ReportRowBackgroundColour",
    ReportSubHeaderBackgroundColour = "ReportSubHeaderBackgroundColour",
    ReportSubHeaderTextColour = "ReportSubHeaderTextColour",
    ResponderCCOwnerOnPropertyEnquiries = "ResponderCCOwnerOnPropertyEnquiries",
    ResponderPropertyEnquiryEmail = "ResponderPropertyEnquiryEmail",
    ResponderPropertyEnquirySMS = "ResponderPropertyEnquirySMS",
    ResponderRegistrationEmail = "ResponderRegistrationEmail",
    ResponderRegistrationSMS = "ResponderRegistrationSMS",
    SalutationPreference = "SalutationPreference",
    SaveOutlookEmails = "SaveOutlookEmails",
    SaveOutlookEmailsSent = "SaveOutlookEmailsSent",
    SchemaUpdateDefaultColorsSet = "SchemaUpdateDefaultColorsSet",
    SchemaUpdatePropertyFeedbackProcessed = "SchemaUpdatePropertyFeedbackProcessed",
    SendAppointmentConfirmationSMSTexts = "SendAppointmentConfirmationSMSTexts",
    SendAppointmentNotificationsToManagingAgents = "SendAppointmentNotificationsToManagingAgents",
    SendAppointmentNotificationsToOccupiers = "SendAppointmentNotificationsToOccupiers",
    SendAppointmentNotificationsToOwners = "SendAppointmentNotificationsToOwners",
    SendAppointmentNotificationsToTenants = "SendAppointmentNotificationsToTenants",
    SendPropertyFeedbackStartDate = "SendPropertyFeedbackStartDate",
    SendPropertyFeedbackStartDateCompanyLettings = "SendPropertyFeedbackStartDateCompanyLettings",
    SendPropertyFeedbackStartDateCompanySales = "SendPropertyFeedbackStartDateCompanySales",
    SendPropertyFeedbackStartDateLettings = "SendPropertyFeedbackStartDateLettings",
    SendPropertyFeedbackStartDateSales = "SendPropertyFeedbackStartDateSales",
    SendRemindersXHoursBeforeAppointment = "SendRemindersXHoursBeforeAppointment",
    ServerDomainName = "ServerDomainName",
    SetMailshotsFollowUpTaskPriority = "SetMailshotsFollowUpTaskPriority",
    SetOwnerFeedbackSentDate = "SetOwnerFeedbackSentDate",
    ShowAppointmentRemindersPrompt = "ShowAppointmentRemindersPrompt",
    ShowEstimateOnWorkOrder = "ShowEstimateOnWorkOrder",
    ShowInactiveItemsInPropertyChain = "ShowInactiveItemsInPropertyChain",
    ShowPropertyDetailsOnWorkOrder = "ShowPropertyDetailsOnWorkOrder",
    SignableAccountType = "SignableAccountType",
    SignableAPIKey = "SignableAPIKey",
    SignableCreateTasks = "SignableCreateTasks",
    SignableLastCheckDate = "SignableLastCheckDate",
    SignableReminderPeriod = "SignableReminderPeriod",
    SiteBranchName = "SiteBranchName",
    SiteCompanyID = "SiteCompanyID",
    SiteCountryCode = "SiteCountryCode",
    SiteCurrencyID = "SiteCurrencyID",
    SiteEmail = "SiteEmail",
    SiteFacebookURL = "SiteFacebookURL",
    SiteFaxNumber = "SiteFaxNumber",
    SiteGeneralLetterheadID = "SiteGeneralLetterheadID",
    SiteGooglePlusURL = "SiteGooglePlusURL",
    SiteInstagramURL = "SiteInstagramURL",
    SiteInvoiceLetterheadID = "SiteInvoiceLetterheadID",
    SiteKeySignOutLetterheadID = "SiteKeySignOutLetterheadID",
    SiteLinkedInURL = "SiteLinkedInURL",
    SiteLocality = "SiteLocality",
    SiteLogoPerBranch = "SiteLogoPerBranch",
    SiteName = "SiteName",
    SitePostcode = "SitePostcode",
    SitePrefixNumeric = "SitePrefixNumeric",
    SitePropertyFeedbackLetterheadID = "SitePropertyFeedbackLetterheadID",
    SitePropertyName = "SitePropertyName",
    SiteReceiptLetterheadID = "SiteReceiptLetterheadID",
    SiteRegion = "SiteRegion",
    SiteRentDemandLetterheadID = "SiteRentDemandLetterheadID",
    SiteStatementLetterheadID = "SiteStatementLetterheadID",
    SiteStreet = "SiteStreet",
    SiteTelephoneNumber = "SiteTelephoneNumber",
    SiteTown = "SiteTown",
    SiteTwitterURL = "SiteTwitterURL",
    SiteUnitedKingdomRegion = "SiteUnitedKingdomRegion",
    SiteWebURL = "SiteWebURL",
    SiteWorkOrderLetterheadID = "SiteWorkOrderLetterheadID",
    SMSFooter = "SMSFooter",
    SMSLastRunDate = "SMSLastRunDate",
    SMSSupplier = "SMSSupplier",
    SparkEnergyExport = "SparkEnergyExport",
    SparkEnergyExportType = "SparkEnergyExportType",
    SpellCheckUpperCase = "SpellCheckUpperCase",
    SplitPropertyAreasByBranch = "SplitPropertyAreasByBranch",
    SplitTenanciesAboutToEndReminderByManagementType = "SplitTenanciesAboutToEndReminderByManagementType",
    SQLCloudBackupLastWeek = "SQLCloudBackupLastWeek",
    StatementConsolidateContractor = "StatementConsolidateContractor",
    StatementExport = "StatementExport",
    StatementFooterText = "StatementFooterText",
    StatementFooterTextLettings = "StatementFooterTextLettings",
    StatementFooterTextSales = "StatementFooterTextSales",
    StatementLetterheadID = "StatementLetterheadID",
    StatementObscureContactBankDetails = "StatementObscureContactBankDetails",
    StatementShowArrears = "StatementShowArrears",
    StatementShowBankDetails = "StatementShowBankDetails",
    StatementShowCommission = "StatementShowCommission",
    StatementShowDepositHeld = "StatementShowDepositHeld",
    StatementShowPropertyReference = "StatementShowPropertyReference",
    StatementShowRecurringFeePeriod = "StatementShowRecurringFeePeriod",
    StatementShowRentPeriod = "StatementShowRentPeriod",
    StatementShowTenancyRent = "StatementShowTenancyRent",
    StatementShowTenancyTerms = "StatementShowTenancyTerms",
    StatementShowWorkOrderBody = "StatementShowWorkOrderBody",
    StatementSuppressPageHeaderOnSubsequentPages = "StatementSuppressPageHeaderOnSubsequentPages",
    SuppressLandlordDetailsCustodialDepositScheme = "SuppressLandlordDetailsCustodialDepositScheme",
    SuppressLandlordDetailsInsuredDepositScheme = "SuppressLandlordDetailsInsuredDepositScheme",
    SuppressNameLinking = "SuppressNameLinking",
    SuppressOverseasTaxRateOnContact = "SuppressOverseasTaxRateOnContact",
    SuppressSendPropertyOffersPrompt = "SuppressSendPropertyOffersPrompt",
    SystemInfoMessageLastCheckDate = "SystemInfoMessageLastCheckDate",
    TDSCustodialAPIKey = "TDSCustodialAPIKey",
    TDSCustodialBranchID = "TDSCustodialBranchID",
    TDSCustodialDepositStatusCheckLastRunDate = "TDSCustodialDepositStatusCheckLastRunDate",
    TDSCustodialMemberID = "TDSCustodialMemberID",
    TDSInsuredAccessToken = "TDSInsuredAccessToken",
    TDSInsuredBranchID = "TDSInsuredBranchID",
    TDSInsuredMemberID = "TDSInsuredMemberID",
    TelephonyModule = "TelephonyModule",
    TenancyAutoRenew = "TenancyAutoRenew",
    TenancyContactStatusID = "TenancyContactStatusID",
    TenancyContactTypeID = "TenancyContactTypeID",
    TenancyEndsDaysPrior = "TenancyEndsDaysPrior",
    TenancyExpiredContactStatusID = "TenancyExpiredContactStatusID",
    TenancyExpiredContactTypeID = "TenancyExpiredContactTypeID",
    TenancyExpiryReminder = "TenancyExpiryReminder",
    TenancyInformation = "TenancyInformation",
    TenancyInformationCommercial = "TenancyInformationCommercial",
    TenancyInformationPrompt = "TenancyInformationPrompt",
    TenancyIntroductionFeeChargeFrequency = "TenancyIntroductionFeeChargeFrequency",
    TenancySetupHideAdditionalClauses = "TenancySetupHideAdditionalClauses",
    TenancySetupHideInspections = "TenancySetupHideInspections",
    TenancySetupHideLandlordFees = "TenancySetupHideLandlordFees",
    TenancySetupHideRentBenefit = "TenancySetupHideRentBenefit",
    TenancySetupHideTenantFees = "TenancySetupHideTenantFees",
    TenancySpecialTermsAndConditions = "TenancySpecialTermsAndConditions",
    TenantFee1Product = "TenantFee1Product",
    TenantFee2Product = "TenantFee2Product",
    TenantFee3Product = "TenantFee3Product",
    TenantIntroductionFee1Product = "TenantIntroductionFee1Product",
    TenantIntroductionFee2Product = "TenantIntroductionFee2Product",
    TenantShopCheckContactMappings = "TenantShopCheckContactMappings",
    TenantShopCouncilDesktopAlert = "TenantShopCouncilDesktopAlert",
    TenantShopExportType = "TenantShopExportType",
    TenantShopIncludeHMOs = "TenantShopIncludeHMOs",
    TenantShopKey = "TenantShopKey",
    TenantShopOwnerID = "TenantShopOwnerID",
    TenantShopPassword = "TenantShopPassword",
    TenantShopSupplierDesktopAlert = "TenantShopSupplierDesktopAlert",
    TheMovingHubAPIKey = "TheMovingHubAPIKey",
    TheMovingHubID = "TheMovingHubID",
    TheMovingHubPrompt = "TheMovingHubPrompt",
    TheMovingHubSubDomain = "TheMovingHubSubDomain",
    TouchRightPassword = "TouchRightPassword",
    TouchRightPrompt = "TouchRightPrompt",
    TouchRightUserName = "TouchRightUserName",
    TransferOverseasTaxMethod = "TransferOverseasTaxMethod",
    TreatArchivedCertificatesAsNotRequired = "TreatArchivedCertificatesAsNotRequired",
    UnderOfferTerminology = "UnderOfferTerminology",
    UpdateContactLastCheckedDateOnOutgoingCalls = "UpdateContactLastCheckedDateOnOutgoingCalls",
    UploadCountryName = "UploadCountryName",
    UploadLastRunDate = "UploadLastRunDate",
    UploadPostcode = "UploadPostcode",
    UploadPropertiesLet = "UploadPropertiesLet",
    UploadPropertiesSold = "UploadPropertiesSold",
    UploadPropertiesSTC = "UploadPropertiesSTC",
    UploadPropertiesUnderOfferAsAvailable = "UploadPropertiesUnderOfferAsAvailable",
    UploadPropertyDefinableFields = "UploadPropertyDefinableFields",
    UploadPropertyDirections = "UploadPropertyDirections",
    UploadPropertyParticulars = "UploadPropertyParticulars",
    UploadRentalPropertiesSTC = "UploadRentalPropertiesSTC",
    UploadRentalPropertiesTenancyRenewals = "UploadRentalPropertiesTenancyRenewals",
    UploadRequired = "UploadRequired",
    UseSiteNameAsEmailFriendly = "UseSiteNameAsEmailFriendly",
    VATAccountingMethod = "VATAccountingMethod",
    VendorPropertyAvailableStatusID = "VendorPropertyAvailableStatusID",
    VendorPropertyAvailableTypeID = "VendorPropertyAvailableTypeID",
    VendorPropertyCompletedStatusID = "VendorPropertyCompletedStatusID",
    VendorPropertyCompletedTypeID = "VendorPropertyCompletedTypeID",
    VendorPropertyNotAvailableStatusID = "VendorPropertyNotAvailableStatusID",
    VendorPropertyNotAvailableTypeID = "VendorPropertyNotAvailableTypeID",
    VeriphyPassword = "VeriphyPassword",
    VeriphyUserName = "VeriphyUserName",
    Version = "Version",
    VersionUpdateForceLogout = "VersionUpdateForceLogout",
    VorensysCustomerID = "VorensysCustomerID",
    VorensysReferencesLastRunDate = "VorensysReferencesLastRunDate",
    VorensysServicesEnabled = "VorensysServicesEnabled",
    WatermarkImageSizePercentage = "WatermarkImageSizePercentage",
    WatermarkPosition = "WatermarkPosition",
    WatermarkText = "WatermarkText",
    WatermarkType = "WatermarkType",
    WebRegistrationLandlordTypeID = "WebRegistrationLandlordTypeID",
    WebRegistrationLastLettingsNegCount = "WebRegistrationLastLettingsNegCount",
    WebRegistrationLastSalesNegCount = "WebRegistrationLastSalesNegCount",
    WebRegistrationLettingsApplicantTypeID = "WebRegistrationLettingsApplicantTypeID",
    WebRegistrationSalesApplicantTypeID = "WebRegistrationSalesApplicantTypeID",
    WebRegistrationSourceID = "WebRegistrationSourceID",
    WebRegistrationStatusID = "WebRegistrationStatusID",
    WebRegistrationTypeID = "WebRegistrationTypeID",
    WebRegistrationVendorTypeID = "WebRegistrationVendorTypeID",
    WebRemovalStatusID = "WebRemovalStatusID",
    WebsiteIntegrationCreateAppRegTasks = "WebsiteIntegrationCreateAppRegTasks",
    WebsiteIntegrationLastRunDate = "WebsiteIntegrationLastRunDate",
    WebSiteRegistrationsLettingsNegotiator = "WebSiteRegistrationsLettingsNegotiator",
    WebSiteRegistrationsSalesNegotiator = "WebSiteRegistrationsSalesNegotiator",
    WebViewingsLastRunDate = "WebViewingsLastRunDate",
    WorkOrderCommissionCalculation = "WorkOrderCommissionCalculation",
    WorkOrderLetterheadID = "WorkOrderLetterheadID",
    WorkOrderQuotationShowTenantDetails = "WorkOrderQuotationShowTenantDetails",
    WorkOrderShowKeyAllocated = "WorkOrderShowKeyAllocated",
    WorkOrderShowLandlordDetails = "WorkOrderShowLandlordDetails",
    WorkOrderShowTenantDetails = "WorkOrderShowTenantDetails",
    WriteRecordChangesToEventLog = "WriteRecordChangesToEventLog"
};

